<template>
  <div class="Notif" :class="`is--${state}`" ref="notif">
    <button class="Notif__close" @click.prevent="closeNotif"><Icon name="cross" /></button>
    <div class="inner">
      <Icon :name="icon" />
      <div class="content">
        <div class="Notif__title">{{ title }}</div>
        <p v-html="text"></p>
        <template v-if="cta">
          <ExternalButtonLink v-if="cta.external" @click="cta.onClick" :href="cta.url">{{ cta.title }}</ExternalButtonLink>
          <ButtonLink v-else :href="cta.url" @click="cta.onClick">{{ cta.title }}</ButtonLink>

        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, watchEffect, onMounted, onBeforeUnmount, nextTick } from 'vue'
  import { useNotifs } from '@/store/notifs'
  import gsap from 'gsap'
  import Icon from '@components/Icon'
  import ButtonLink from "@components/navigation/ButtonLink";
  import ExternalButtonLink from "@components/navigation/ExternalButtonLink";

  export default {
    components : {ExternalButtonLink, ButtonLink, Icon },
    props: [ 'notif'],
    setup(props) {
      const {icon, title, text, state, cta} = props.notif;
      const notif = ref(null)
      const closeNotif = () => useNotifs.delete()

      onMounted(() => {
        nextTick(() => gsap.from(notif.value, { yPercent: 20, ease: 'power3.out', duration: 1.2 }))
      })

      return {
        icon, title, text, state, cta,
        closeNotif
      }
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/_Notif.scss";
</style>
